import React from 'react';

export default function Footer() {
  const currentYear = new Date().getFullYear();

  return (
    <footer className="bg-white border-t border-gray-200 py-4 sm:py-6">
      <div className="container mx-auto px-4 flex flex-col items-center">
        <div className="text-xs font-light text-gray-600 mb-2">
          Designed and Developed by
        </div>
        <a 
          href="https://mrprimo.org" 
          target="_blank" 
          rel="noopener noreferrer" 
          className="flex items-center hover:opacity-80 transition-opacity"
        >
          <img 
            src="/new-logo-transparent.png" 
            alt="Mr. Primo Logo" 
            className="h-8 sm:h-12 w-auto object-contain"
          />
        </a>
        <div className="text-xs font-extralight text-gray-500 mt-2">
          {currentYear} All Rights Reserved
        </div>
        {/* Privacy Policy & Terms link in app footer */}
        <a
          href="/privacy-policy-terms.html"
          className="mt-1 text-[11px] text-gray-400 hover:text-gray-500"
          target="_blank"
          rel="noopener noreferrer"
        >
          Privacy Policy &amp; Terms
        </a>
      </div>
    </footer>
  );
}
